import * as React from "react";
import { observer, inject } from "mobx-react";
import { Link, withRouter, RouteComponentProps } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";

import { CustomerRequest } from "src/requests/CustomerRequests";

import { CustomerType, FilterToContacts, Contact, Customer, ExtractFriendlyName } from "src/model/Customer";

import { CustomerListStore } from "src/stores/CustomerListStore";

import LoadingWidget from "../common/LoadingWidget";
import { CustomerLink } from "../common/CustomerLink";
import { successMessage, errorMessage } from "../common/Toast";

export interface Props extends RouteComponentProps<any> {
    toggleFunction: () => void;
    onCreate?: (customer: Customer) => void;
    noRedirect?: boolean;
    customerListStore?: CustomerListStore;
}
export interface State {
    wasValidatedCustomer: boolean;
    isLoading: boolean;
    isWarning: boolean;
    duplicatedName: Contact[];
}

@inject("customerListStore")
@observer
class AddContact extends React.Component<Props, State & CustomerRequest> {
    constructor(props: Props) {
        super(props);
        this.state = {
            wasValidatedCustomer: false,
            isLoading: false,
            isWarning: false,
            duplicatedName: [],
            firstName: "",
            lastName: "",
            phoneNumber: "",
            type: "CONTACT"
        };
    }

    handleOnChange = (event: React.FormEvent<HTMLInputElement>): void => {
        const target = event.currentTarget;
        const value = target.value;
        const name = target.name;

        const state = this.state;
        state[name] = value;
        this.setState(state);

        if (this.state.firstName !== "" && this.state.lastName !== "" && (name === "firstName" || name === "lastName") && value.length > 4) {
            const { customerListStore } = this.props;
            if (!customerListStore) {
                throw new Error(" ** No Customer Store **");
            }
            customerListStore.refreshSimilarContacts(this.state.firstName || "", this.state.lastName || "");
        }
    };

    submitContact = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();

        if (this.formValidation() && this.state.isLoading === false) {
            this.setState({ isLoading: true, wasValidatedCustomer: false });
            this.props
                .customerListStore!.addCustomer(this.state)
                .then(customer => {
                    if (this.props.onCreate) {
                        this.props.onCreate(customer);
                    }
                    if (!this.props.noRedirect) {
                        this.props.history!.push(`/customer/${customer.id}/overview`);
                    } else {
                        this.props.toggleFunction();
                    }
                    return customer;
                })
                .then(customer => successMessage(`${ExtractFriendlyName(customer)} has been created.`))
                .catch(error => errorMessage(error));
        } else {
            this.setState({ isLoading: false, wasValidatedCustomer: true });
        }
    };

    formValidation = () => {
        return this.state.firstName !== "" && this.state.lastName !== "" ? true : false;
    };

    render(): React.ReactNode {
        const { customerListStore } = this.props;
        if (!customerListStore) {
            throw new Error(" ** No Customer Store **");
        }
        const similar = FilterToContacts(customerListStore!.similarCustomers.results);

        return (
            <form
                className={"mt-3 needs-validation " + (this.state.wasValidatedCustomer === true ? "was-validated" : "")}
                noValidate={true}
                onSubmit={e => this.submitContact(e)}
                id="createCustomerContact"
            >
                <div className="form-group">
                    <label htmlFor="firstname">
                        First Name <span className="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        id="firstname"
                        placeholder="First name"
                        name="firstName"
                        value={this.state.firstName}
                        onChange={this.handleOnChange}
                        required={true}
                        disabled={this.state.isLoading}
                    />
                    <div className="valid-feedback">Looks good!</div>
                </div>
                <div className="form-group">
                    <label htmlFor="lastname">
                        Last Name <span className="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        id="lastname"
                        placeholder="Last name"
                        name="lastName"
                        value={this.state.lastName}
                        onChange={this.handleOnChange}
                        required={true}
                        disabled={this.state.isLoading}
                    />
                    <div className="valid-feedback">Looks good!</div>
                </div>
                <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="inputGroupPrepend">
                                <FontAwesomeIcon icon={faPhone} />
                            </span>
                        </div>
                        <input
                            type="text"
                            className="form-control not-required"
                            id="phone"
                            placeholder="Phone number"
                            name="phoneNumber"
                            value={this.state.phoneNumber}
                            onChange={this.handleOnChange}
                            aria-describedby="phoneHelp"
                            disabled={this.state.isLoading}
                        />
                    </div>
                </div>
                {similar.length > 0 && (
                    <div className="alert alert-warning" role="alert">
                        <strong> Warning: </strong>The following customer(s) with similar names already exist. Please check these before continuing to
                        avoid duplicates:
                        <ul className="pl-4 mb-0 mt-2">
                            {similar.map((customer, index) => (
                                <li key={index}>
                                    {" "}
                                    <CustomerLink customer={customer} />
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                <div className="modal-footer px-0">
                    <button className="btn btn-secondary" type="button" onClick={this.props.toggleFunction}>
                        Cancel
                    </button>
                    {customerListStore.loading && <LoadingWidget />}
                    <button className="btn btn-primary ml-auto" type="submit" form="createCustomerContact">
                        Create Contact
                    </button>
                </div>
            </form>
        );
    }
}

export default withRouter<Props>(AddContact);



// WEBPACK FOOTER //
// ./src/components/customer/NewContact.tsx